import PropTypes from "prop-types";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdCancel } from "react-icons/md";
import title from "../../../assets/admin/title.svg";
import sidebar_dashboard from "../../../assets/admin/sidebar_dashboard.svg";
import sidebar_wine from "../../../assets/admin/sidebar_wine.svg";
import sidebar_restaurant from "../../../assets/admin/sidebar_restaurant.svg";
import sidebar_usersettings from "../../../assets/admin/sidebar_usersettings.svg";
import sidebar_addUser from "../../../assets/admin/sidebar_add-user.svg";
import sidebar_settings from "../../../assets/admin/sidebar_settings.svg";
import order from "../../../assets/admin/order.svg";
import proposalIcon from "../../../assets/admin/proposal.svg";
import { toast } from "react-toastify";
import { TbLogout2 } from "react-icons/tb";
import axios from "axios";
import { IoIosArrowForward } from "react-icons/io";

const Sidebar = ((props, ref) => {
  const {
    closeModal,
    showSidebarForMobile,
    setShowSidebarForMobile,
    hasPermission
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRef = useRef();
  const pathname = location.pathname;

  // State management
  const [selectedRadio, setSelectedRadio] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);

  // Handlers
  const toggleDropdown = (path) => {
    setOpenDropdown(openDropdown === path ? null : path);
  };

  const handleRadioChange = (e, radioName, route) => {
    e.stopPropagation();
    if (route) {
      navigate(route);
    }
    const validRadioNames = [
      "Wine",
      "Restaurant",
      // "RestaurantAdd",
      "User",
      "UserAdd",
      "Profile",
      "ChangePassword",
    ];
    if (validRadioNames.includes(radioName)) {
      setSelectedRadio(radioName);
    }
  };

  const userLogout = async () => {
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const token = localStorage.getItem('token')

    try {
      await axios.post(
        `${apiUrl}/api/v1/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ).then((response) => {
        if (response.status === 200) {
          clearLocalStorage();
          toast.success(response?.data?.message, { theme: "colored", autoClose: 1000 });
          navigate("/admin/login");
        }
      })
    } catch (err) {
      if (err.status === 401) {
        clearLocalStorage();
        toast.success(err?.response?.data?.message, { theme: "colored", autoClose: 1000 });
        navigate("/admin/login");
      }
    }
  }

  const clearLocalStorage = () => {
    ["Role", "token", "currentRestId", "loginUserId", "type", "RoleName", "RoleId"].forEach(
      key => localStorage.removeItem(key)
    );
  };

  const mainItems = [
    {
      path: hasPermission("Dashboard", "view") && "/admin/dashboard",
      label: "Dashboard",
      icon: sidebar_dashboard,
      isDropdown: false,
      isPermission: hasPermission("Dashboard", "view"),
    },
    {
      path: hasPermission("Wines", "view") && "/admin/wine",
      label: "Vini",
      icon: sidebar_wine,
      isDropdown: true,
      isPermission: hasPermission("Wines", "view"),
      dropdownContent: (
        <div className="m-1 pt-3 pb-3">
          {hasPermission("Wines", "view") && (
            <label className="flex items-center justify-between p-1">
              <span className="ml-2 cursor-pointer">
                <Link
                  to={"/admin/wine"}
                  onClick={(e) => {
                    e.stopPropagation();
                    closeModal();
                  }}>
                  Tutti i vini
                </Link>
              </span>
              <input
                type="radio"
                className="custom-checkbox"
                name="wineOptions"
                value="Wine"
                checked={selectedRadio === "Wine"}
                onChange={(e) => handleRadioChange(e, "Wine", "/admin/wine")}
              />
            </label>
          )}
        </div>
      ),
    },
    {
      path: hasPermission("Restaurants", "view") && "/admin/restaurantManagement",
      label: "Gestione Ristoratore",
      icon: sidebar_restaurant,
      isDropdown: true,
      isPermission: hasPermission("Restaurants", "view"),
      dropdownContent: (
        <div className="m-1 pt-3 pb-3 space-y-4">
          {hasPermission("Restaurants", "view") && (
            <label className="flex items-center justify-between gap-x-2 border-[#983D4A]">
              <span className="cursor-pointer">
                <Link
                  to={"/admin/restaurantManagement"}
                  onClick={(e) => {
                    e.stopPropagation();
                    closeModal();
                  }}>
                  Lista Ristoranti
                </Link>
              </span>
              <input
                type="radio"
                className="custom-checkbox"
                checked={selectedRadio === "Restaurant"}
                onChange={(e) => handleRadioChange(e, "Restaurant", "/admin/restaurantManagement")}
              />
            </label>
          )}
          {/* <label className="flex items-center justify-between">
            <span className="ml-2 cursor-pointer">Aggiungi Ristoranti</span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "RestaurantAdd"}
              onChange={(e) => handleRadioChange(e, "RestaurantAdd", "/admin/restaurant-add")}
            />
          </label> */}
        </div>
      ),
    },
    {
      path: "/admin/allergensManagement",
      label: "Gestisci Allergeni",
      icon: sidebar_addUser,
      isDropdown: false,
      isPermission: true,
    },
    {
      path: "/admin/orderManagement",
      label: "Tutti gli Ordini",
      icon: order,
      isDropdown: false,
      isPermission: true,
    },
    {
      path: hasPermission("Proposals", "view") && "/admin/proposals",
      label: "Proposals",
      icon: proposalIcon,
      isDropdown: false,
      isPermission: hasPermission("Proposals", "view"),
    },
    {
      path: hasPermission("Users", "view") && "/admin/userManagement",
      label: "Gestione Utenti",
      icon: sidebar_usersettings,
      isDropdown: true,
      isPermission: hasPermission("Users", "view"),
      dropdownContent: (
        <div className="m-1 pt-3 pb-3 space-y-4">
          {hasPermission("Users", "view") && (
            <label className="flex items-center justify-between pb-3 border-b border-[#983D4A]">
              <span className="ml-2 cursor-pointer">
                <Link
                  to={"/admin/userManagement"}
                  onClick={(e) => {
                    e.stopPropagation();
                    closeModal();
                  }}>
                  Lista Utenti
                </Link>
              </span>
              <input
                type="radio"
                className="custom-checkbox"
                checked={selectedRadio === "User"}
                onChange={(e) => handleRadioChange(e, "User", "/admin/userManagement")}
              />
            </label>
          )}
          {hasPermission("Users", "add") && (
            <label className="flex items-center justify-between">
              <span className="cursor-pointer">
                <Link to={"/admin/user-add"} onClick={(e) => {
                  e.stopPropagation();
                  closeModal();
                }}>
                  Aggiungi Utenti
                </Link>
              </span>
              <input
                type="radio"
                className="custom-checkbox"
                checked={selectedRadio === "UserAdd"}
                onChange={(e) => handleRadioChange(e, "UserAdd", "/admin/user-add")}
              />
            </label>
          )}
        </div>
      ),
    },
    {
      path: hasPermission("Roles", "view") && "/admin/userRole",
      label: "Pannello Amministrazione",
      icon: sidebar_addUser,
      isDropdown: false,
      isPermission: hasPermission("Roles", "view"),
    }
  ];

  const settingsItems = [
    {
      path: "/admin/settings",
      label: "Impostazioni",
      icon: sidebar_settings,
      isDropdown: true,
      dropdownContent: (
        <div className="m-1 pt-3 pb-3 space-y-4">
          <label className="flex items-center justify-between pb-3 border-b border-[#983D4A]">
            <span className="w-[100px] cursor-pointer">
              <Link
                to={"/admin/settings"}
                onClick={(e) => {
                  e.stopPropagation();
                  closeModal();
                }}>
                Impostazioni del profilo
              </Link>
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              checked={selectedRadio === "Profile"}
              onChange={(e) => handleRadioChange(e, "Profile", "/admin/settings")}
            />
          </label>
          <label className="flex items-center justify-between ">
            <span className="cursor-pointer w-[120px] block">
              <Link
                to={"/admin/changePassword"}
                onClick={(e) => {
                  e.stopPropagation();
                  closeModal();
                }}>
                Cambiare la password
              </Link>
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              checked={selectedRadio === "ChangePassword"}
              onChange={(e) => handleRadioChange(e, "ChangePassword", "/admin/changePassword")}
            />
          </label>
        </div>
      ),
    },
  ];

  useImperativeHandle(ref, () => ({
    dropdown() {
      setOpenDropdown(null);
    },
  }));

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSidebarForMobile && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowSidebarForMobile(false);
      }
    };
    if (showSidebarForMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSidebarForMobile, setShowSidebarForMobile]);

  useEffect(() => {
    switch (true) {
      //Condition For Admin Dashboard Page
      case /^\/admin\/dashboard(\/.*)?$/.test(pathname):
        break;
      //Condition For Admin Wine Page
      case /^\/admin\/wine(\/.*)?$/.test(pathname):
        setSelectedRadio("Wine");
        setOpenDropdown("/admin/wine");
        break;
      //Condition For Admin RestaurantManagement Page
      case /^\/admin\/restaurantManagement(\/.*)?$/.test(pathname):
        setSelectedRadio("Restaurant");
        setOpenDropdown("/admin/restaurantManagement");
        break;
      //Condition For Admin Restaurant-Add Page
      // case /^\/admin\/restaurant-add(\/.*)?$/.test(pathname):
      //   setSelectedRadio("RestaurantAdd");
      //   setOpenDropdown("/admin/restaurantManagement");
      //   break;
      //Condition For Admin Winestock Page
      case /^\/admin\/wineStock(\/.*)?$/.test(pathname):
        setSelectedRadio("Restaurant");
        setOpenDropdown("/admin/restaurantManagement");
        break;
      //Condition For Admin UserManagement Page
      case /^\/admin\/userManagement(\/.*)?$/.test(pathname):
        setSelectedRadio("User");
        setOpenDropdown("/admin/userManagement");
        break;
      //Condition For Admin User-Add Page
      case /^\/admin\/user-add(\/.*)?$/.test(pathname):
        setSelectedRadio("UserAdd");
        setOpenDropdown("/admin/userManagement");
        break;
      //Condition For Admin SettingsPage
      case /^\/admin\/settings(\/.*)?$/.test(pathname):
        setSelectedRadio("Profile");
        setOpenDropdown("/admin/settings");
        break;
      //Condition For Admin ChangePassowrdPage
      case /^\/admin\/changePassword(\/.*)?$/.test(pathname):
        setSelectedRadio("ChangePassword");
        setOpenDropdown("/admin/settings");
        break;
      default:
        setOpenDropdown(null);
        break;
    }
  }, [pathname]);

  return (
    <div ref={sidebarRef} className={`lg:max-w-[250px] max-w-[200px] h-[100%] bg-[#F6EFEF] flex flex-col pt-4 rounded-3xl ${showSidebarForMobile ? "side-nav-bar-show" : "side-nav-bar"} px-5 relative`}>
      <MdCancel onClick={() => setShowSidebarForMobile(!showSidebarForMobile)} className="w-5 h-5 cancel-btn absolute top-3 right-3" color="gray" />
      <div className="text-center relative max-w-[150px] m-auto lg:p-0 px-4">
        <img src={title} className="m-4 ml-auto mr-auto w-full" height={50} width={150} />
        <div className="px-4 mt-2">
          <div className="items-center px-4 w-full h-[1px] bg-gray-300"></div>
        </div>
      </div>
      <nav className="flex flex-col flex-grow font-sans-serif items-center w-[171px] nav-side-bar">
        {mainItems?.map((route, index) => route?.isPermission && (
          <div
            key={index}
            className={`w-full py-1 px-4 items-center text-xs font-normal poppins-regular rounded-3xl my-2 group
                ${pathname === route?.path || (
                (route.path.includes("dashboard") && /^\/admin\/dashboard(\/.*)?$/.test(location.pathname)) ||
                (route.path.includes("wine") && /^\/admin\/wine\/.+/.test(location.pathname)) ||
                (route.path.includes("restaurantManagement") && /^\/admin\/(restaurantManagement|wineStock|restaurant-add)(\/.*)?$/.test(location.pathname)) ||
                (route.path.includes("userManagement") && /^\/admin\/(userManagement|user-add)(\/.*)?$/.test(location.pathname)) ||
                (route.path.includes("proposals") && /^\/admin\/proposals(\/.*|-edit\/.*)?$/.test(location.pathname)) ||
                (route.path.includes("settings") && /^\/admin\/settings(\/.*)?$/.test(location.pathname))
              )
                ? "text-[#FFFFFF] bg-[#8B2433]"
                : "text-[#8B2433] bg-[#f7eeef] border-[1.5px] border-[#8B243385] hover:text-white hover:bg-[#8b2532]"
              }`}
          >
            <div className={`flex items-center cursor-pointer ${route?.isDropdown && openDropdown === route?.path ? "pb-2 border-b border-[#983D4A]" : ""}`}>
              <Link
                className={`w-full flex items-center py-2 gap-2 ${route.label === "Vini" ? "py-2" : "py-2"} ${route.label === "Gestione Utenti" ? "py-2" : "py-2"}`}
                to={route?.path}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!route?.isDropdown) {
                    navigate(route?.path);
                    setOpenDropdown(null);
                  }
                  toggleDropdown(route?.path)
                  closeModal();
                }}
              >
                <img
                  src={route?.icon}
                  className={`transition-all duration-300 ease-in-out group-hover:invert
                     ${pathname === route?.path || (
                      (route.path.includes("dashboard") && /^\/admin\/dashboard(\/.*)?$/.test(location.pathname)) ||
                      (route.path.includes("wine") && /^\/admin\/wine\/.+/.test(location.pathname)) ||
                      (route.path.includes("restaurantManagement") && /^\/admin\/(restaurantManagement|wineStock|restaurant-add)(\/.*)?$/.test(location.pathname)) ||
                      (route.path.includes("userManagement") && /^\/admin\/(userManagement|user-add)(\/.*)?$/.test(location.pathname)) ||
                      (route.path.includes("proposals") && /^\/admin\/proposals(\/.*|-edit\/.*)?$/.test(location.pathname)) ||
                      (route.path.includes("settings") && /^\/admin\/settings(\/.*)?$/.test(location.pathname))
                    )
                      ? "invert"
                      : ""
                    }`}
                  height={route.label === "Vini" ? 6 : 15}
                  width={route.label === "Vini" ? 5 : 15}
                />
                <span className={route.label === "Vini" ? "ml-2" : ""}>{route.label}</span>
              </Link>
              {route?.isDropdown && <IoIosArrowForward onClick={() => toggleDropdown(route?.path)} className={`w-5 h-4 rounded-full ml-auto transition-transform transform duration-200 ${openDropdown === route.path ? "transform rotate-90" : ""}`} />}
            </div>
            {route?.isDropdown && openDropdown === route?.path && route?.dropdownContent}
          </div>
        ))}
      </nav>

      <div className="w-[100%] mt-2 items-center text-xs font-normal poppins-regular rounded-3xl group text-[#8B2433] bg-[#f7eeef] hover:text-white hover:bg-[#8b2532]">
        <Link
          // border border-[#8B243385]
          className={`mt-auto py-2 px-3 gap-2 font-normal text-red-700 text-xs rounded-2xl flex items-center  ${pathname === (/^\/restaurantPanel\/logout\/.+/.test(pathname))
            ? "text-white bg-[#8a2533]"
            : "text-black-700 bg-[#f7eeef] hover:text-white hover:bg-[#8b2532]"
            }`}
          onClick={() => userLogout()}
        >
          <TbLogout2 className="text-lg" />
          Log Out
        </Link>
      </div>

      {settingsItems?.map((route, index) => (
        <div
          key={index}
          className={`w-[100%] py-1 px-4 items-center text-xs font-normal poppins-regular rounded-3xl my-2 group 
                ${location.pathname === route?.path || (route.path.includes("settings") && /^\/admin\/(settings|changePassword)(\/.*)?$/.test(location.pathname))
              ? "text-[#FFFFFF] bg-[#8B2433]"
              : "text-[#8B2433] bg-[#f7eeef] border-[1.5px] border-[#8B243385] hover:text-white hover:bg-[#8b2532]"
            }`}
        >
          <div className={`flex items-center cursor-pointer ${route.isDropdown && openDropdown === route.path ? "pb-2 border-b border-[#983D4A]" : ""}`}>
            <Link
              className="w-full flex items-center justify-start gap-x-2 py-1"
              to={route?.path}
              onClick={(e) => {
                e.stopPropagation();
                if (!route?.isDropdown) {
                  navigate(route?.path);
                  setOpenDropdown(null);
                }
                closeModal();
              }}
            >
              <img
                src={route?.icon}
                className={`transition-all duration-300 ease-in-out group-hover:invert 
                     ${pathname === route?.path || (route.path.includes("settings") && /^\/admin\/(settings|changePassword)(\/.*)?$/.test(pathname))
                    ? "invert"
                    : ""
                  }`}
                height={15}
                width={15}
              />
              <span>{route?.label}</span>
            </Link>
            {route?.isDropdown && <IoIosArrowForward onClick={() => toggleDropdown(route?.path)} className={`w-5 h-4 rounded-full ml-auto transition-transform transform duration-200 ${openDropdown === route.path ? "transform rotate-90" : ""}`} />}
          </div>
          {route?.isDropdown && openDropdown === route?.path && route?.dropdownContent}
        </div>
      ))}
    </div>
  );
});

// Define PropTypes
Sidebar.propTypes = {
  closeModal: PropTypes.func,
  showSidebarForMobile: PropTypes.bool,
  setShowSidebarForMobile: PropTypes.func,
  hasPermission: PropTypes.func,
};

export default forwardRef(Sidebar);